$(document).ready(function() {
  // COMMON
  setDateTimePickerListener();

  $('form').on('cocoon:after-insert', function() {
    setDateTimePickerListener();
  });

  $('input.autocomplete').easyAutocomplete({
    minLength: 2,
    source: '/breeds/autocomplete.json',
  });

  if ( $('input#use_organization_address').length > 0 ) {
    $('input#use_organization_address').on('click', function() {
      const organization_id = $('select#trial_organization_id option:selected').val();
      const remit_to_name = $('input#trial_remit_to_name');
      const remit_to_street = $('input#trial_remit_to_street');
      const remit_to_city = $('input#trial_remit_to_city');
      const remit_to_state = $('input#trial_remit_to_state');
      const remit_to_zip = $('input#trial_remit_to_zip');
      if ( $('input#use_organization_address').is(':checked') ) {
        if (organization_id.length > 0) {
          $.ajax({
            url: '/admin/organizations/' + organization_id + '/remit_to',
            dataType: 'json',
            success: function(data) {
              remit_to_name.val(data.name);
              remit_to_street.val(data.street);
              remit_to_city.val(data.city);
              remit_to_state.val(data.state);
              remit_to_zip.val(data.zip);
            }
          });
        }
      } else {
        remit_to_name.val('');
        remit_to_street.val('');
        remit_to_city.val('');
        remit_to_state.val('');
        remit_to_zip.val('');
      }
    });
  }

  $('.best_in_place').best_in_place();

  // ORDER FORM
  $('#billing-information-same-as-account').change(
    function() {
      if ($(this).is(':checked')) {
        $('#unpopulated-billing-information').hide();
        $('#populated-billing-information').show();
      }
      else {
        $('#unpopulated-billing-information').show();
        $('#populated-billing-information').hide();
      }
    }
  );
});

function setDateTimePickerListener() {
  $('input.datetimepicker').flatpickr({
    allowInput: true,
    enableTime: true,
    dateFormat: 'h:i K m/d/Y',
    minuteIncrement: 15
  });
  $('input.datepicker').flatpickr({
    allowInput: true,
    dateFormat: 'm/d/Y'
  });
  $('input.timepicker').flatpickr({
    enableDate: false,
    enableTime: true,
    format: 'h:i K',
    minuteIncrement: 15
  });
}
